import React, { createContext, useMemo, useState, PropsWithChildren } from 'react';

// export type StateType = { [key: string]: string };
export type StateType = Record<string, Object>;

export type AppContextType = {
  ctxState: StateType;
  setCtxState: React.Dispatch<React.SetStateAction<StateType>>;
};

export const AppContext = createContext<AppContextType | null>(null);

export const AppContextProvider = (props: PropsWithChildren<{}>) => {
  // const [ctxState, setCtxState] = useState<any[]>([]);
  const [ctxState, setCtxState] = useState<StateType>({});
  const state = useMemo(() => ({ ctxState, setCtxState }), [ctxState]);

  return <AppContext.Provider value={state}>{props.children}</AppContext.Provider>;
};
